import React from "react";

const LicenseCard = ({ planName, price, features, buttonText }) => {
  return (
    <div className="max-w-sm bg-white shadow-lg rounded-lg p-6 border border-gray-200">
      {/* Plan Adı */}
      <h2 className="text-lg font-medium text-gray-700 mb-2">{planName}</h2>

      {/* Fiyat */}
      <div className="flex items-end mb-4">
        <span className="text-4xl font-bold text-gray-900 mr-1">${price}</span>
        <span className="text-sm text-gray-600 mb-1">/month</span>
      </div>

      {/* Özellikler */}
      <ul className="space-y-2 text-gray-600 mb-6">
        {features.map((feature, index) => (
          <li
            key={index}
            className={`flex items-center ${
              feature.available ? "" : "text-gray-400 line-through"
            }`}
          >
            <span
              className={`mr-2 ${
                feature.available ? "text-blue-500" : "text-gray-400"
              }`}
            >
              {feature.available ? "✔" : "✘"}
            </span>
            {feature.name}
          </li>
        ))}
      </ul>

      {/* Buton */}
      <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 rounded-md transition duration-300">
        {buttonText}
      </button>
    </div>
  );
};

export default LicenseCard;
